import * as type from "./types";

export function searchItemName(value, name, cid) {
  return {
    type: type.SEARCH_ITEM_NAME,
    payload: value,
    name,
    cid
  };
}

export function storeItemNameResult(list, name) {
  return {
    type: type.STORE_ITEM_NAME_RESULT,
    payload: list,
    name
  };
}
